var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('fieldset',[_c('legend',[_vm._v("Image")]),_c('UploadImage')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }